import {
  AcceptedDocFormatsType,
  fileTypeMaxSizeMap,
  ACCEPTED_FILE_FORMATS,
  AcceptedFileFormatsType,
} from "@/constants";
import { toast } from "@/components/toast";
import { split, toLower } from "lodash";

export const validateFile = (file: File | undefined): boolean => {
  if (!file) {
    toast.error("Error on uploading file");

    return false;
  }

  const isValidFormat = ACCEPTED_FILE_FORMATS.includes(
    file.type as AcceptedFileFormatsType,
  );

  if (!isValidFormat) {
    toast.error("Invalid file format");

    return false;
  }

  const maxSize = fileTypeMaxSizeMap[file.type as AcceptedFileFormatsType] ?? 0;
  const isValidSize = file.size <= maxSize;

  if (!isValidSize) {
    toast.error(`Maximum file size exceeded: ${maxSize / 1000000} MB`);

    return false;
  }

  return true;
};

export const transformFileFormats = (formats?: string | null) => {
  return formats
    ? split(formats, ",")
        .map(format => {
          const _format = toLower(format.replace(/^\./, ""));

          if (_format === AcceptedDocFormatsType.Pdf) {
            return `application/${_format}`;
          }

          if (
            _format === AcceptedDocFormatsType.Jpg ||
            _format === AcceptedDocFormatsType.Jpeg
          ) {
            return ".jpg,.jpeg,image/jpg,image/jpeg";
          }

          return _format;
        })
        .join(",")
    : "";
};
